import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from '@/components/ui/sonner';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import QuickContactWidget from '@/components/QuickContactWidget';
import Home from '@/pages/Home';
import BuildOnYourLot from '@/pages/BuildOnYourLot';
import FloorPlans from '@/pages/FloorPlans';
import FloorPlanDetail from '@/pages/FloorPlanDetail';
import Portfolio from '@/pages/Portfolio';
import InvestorBuilds from '@/pages/InvestorBuilds';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import CostEstimate from '@/pages/CostEstimate';
import AdminDashboard from '@/pages/AdminDashboard';
import Warranty from '@/pages/Warranty';

function App() {
  // Initialize Tawk.to chat widget
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/6761f4c1af5bfec1dbe19a39/1ifjn15f4';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/build-on-your-lot" element={<BuildOnYourLot />} />
            <Route path="/floor-plans" element={<FloorPlans />} />
            <Route path="/floor-plans/:id" element={<FloorPlanDetail />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/investor-builds" element={<InvestorBuilds />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cost-estimate" element={<CostEstimate />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Footer />
          <QuickContactWidget />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
